import {Space} from 'antd';
import styled from 'styled-components';
import Card from '../../../../Card';
import {typographyStyles} from '../../../../../utils/styles';

const StyledUsageMonitoring = styled(Card)`
  .ant-card-body {
    & > p {
      ${typographyStyles.body.regular};
      color: ${props => props.theme.colors.neutral_7};
    }
    h3 {
      ${typographyStyles.heading.h5};
      margin-bottom: 0;

      svg {
        height: 20px;
        width: 20px;
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
    }
  }
  .ant-card-head {
    flex-direction: unset;
    padding: 0 24px;
  }

  .ant-divider + h3 {
    ${typographyStyles.body.medium};
    margin-bottom: 16px;
  }
`;

const StyledUsageMonitoringServicesList = styled(Space)`
  width: 100%;
  & > div {
    flex: 0 0 calc(50% - 8px);
  }
`;

const StyledUsageMonitoringService = styled.div`
  ${typographyStyles.body.regular};
  align-items: center;
  border: 1px solid ${props => props.theme.colors.neutral_5};
  border-radius: ${props => props.theme.border_radius.standard};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: center;
  line-height: 24px;
  padding: 8px;
  transition: .2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.neutral_7};
    cursor: pointer;
  }

  img {
    height: 24px;
    margin-right: 8px;
    width: 24px;
  }

  &.disabled {
    cursor: unset;
    opacity: 0.4;
    pointer-events: none;
  }
`;

const StyledUsageMonitoringConnectedService = styled.div`
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: space-between;
  padding: 8px 0;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${props => props.theme.colors.neutral_2};
  }

  &.disabled {
    cursor: unset;
    opacity: 0.4;
    pointer-events: none;
  }
`;

export {
  StyledUsageMonitoring,
  StyledUsageMonitoringService,
  StyledUsageMonitoringServicesList,
  StyledUsageMonitoringConnectedService,
}
